import { render } from "./section-desc-column.vue?vue&type=template&id=105f74fe"
import script from "./section-desc-column.vue?vue&type=script&lang=js"
export * from "./section-desc-column.vue?vue&type=script&lang=js"

import "./section-desc-column.vue?vue&type=style&index=0&id=105f74fe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__